import { produce } from 'immer'
import { State } from '../typings'
import { BillTo } from '@user/store/entityLocations'

export type SelectBillToAction = {
  type: 'selectBillTo'
  payload: BillTo | undefined
}

export const selectBillTo = produce<State, [SelectBillToAction['payload']]>(
  (draft, payload) => {
    draft.externalBillTo = payload
    draft.externalLocations = []
    draft.matches = new Map()
  },
)
